import classNames from "classnames";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import Popup from "reactjs-popup";

import arrowLeft from "../../../../images/table-image/icon/arrow-left.svg";
import arrowRight from "../../../../images/table-image/icon/arrow-right.svg";
import calendarIcon from "../../../../images/table-image/icon/calendar-black-icon.svg";
import { formatDate } from "../../../helpers/DateFormatters";

type Props = {
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (...args: any[]) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialDate?: any;
};

function TaskDateSelect({ disabled, initialDate, onChange }: Props) {
  // State
  const [date, setDate] = useState(initialDate);
  const [activeStartDate, setActiveStartDate] = useState(null);
  const [dateString, setDateString] = useState(formatDate(date));
  const [showPopup, setShowPopup] = useState(false);

  // Hooks
  useEffect(() => {
    if (initialDate) {
      setDateString(formatDate(initialDate));
      setDate(initialDate);
    } else {
      setDateString("");
      setDate(null);
    }
  }, [initialDate]);

  // @ts-expect-error TS(7006) FIXME: Parameter 'newDate' implicitly has an 'any' type.
  function onCalendarChange(newDate) {
    // Set date
    setDate(newDate);
    setDateString(formatDate(newDate));

    // Close popup
    onClose();

    // Update date in parent
    onChange(newDate);
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  function onInputChange(event) {
    const newDateString = event.target.value;

    // Set dateString without any conditions, since it defines the value in input
    setDateString(newDateString);

    // Try to parse a date
    if (newDateString != null && newDateString != "") {
      const dateParts = newDateString.split("/");
      const month = Number(dateParts[0]);
      const day = Number(dateParts[1]);
      const year = Number(dateParts[2]);

      if (year >= 2000 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
        const newDate = new Date(year, month - 1, day);

        // @ts-expect-error TS(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
        if (!isNaN(newDate)) {
          setDate(newDate);
          setActiveStartDate(
            // @ts-expect-error TS(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
            new Date(newDate.getFullYear(), newDate.getMonth(), 1),
          );
          onChange(newDate);
        }
      }
    }
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
  function onActiveStartDateChange(value) {
    setActiveStartDate(value.activeStartDate);
  }

  function setToday() {
    const today = new Date();
    // @ts-expect-error TS(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
    setActiveStartDate(new Date(today.getFullYear(), today.getMonth(), 1));
    onCalendarChange(today);
  }

  function onOpen() {
    setShowPopup(true);
  }

  function onClose() {
    setShowPopup(false);
  }

  const triggerClasses = classNames({
    active: showPopup,
    "table-cell--disabled": disabled,
  });

  const modalTrigger = (
    // @ts-expect-error TS(2322) FIXME: Type 'string' is not assignable to type 'number'.
    <li className={triggerClasses} tabIndex="0">
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {dateString?.length > 0 ? dateString : <span>– Select –</span>}
      <img src={calendarIcon} alt="calendar-icon" />
    </li>
  );

  return (
    <Popup
      trigger={modalTrigger}
      disabled={disabled}
      position="bottom left"
      open={showPopup}
      onOpen={onOpen}
      onClose={onClose}
      keepTooltipInside
    >
      <div
        className="select-small-wrap calendar-wrap task-date-popup"
        data-testid="date-cell-popup"
      >
        <input
          className="input-date"
          data-testid="date-cell-input"
          // @ts-expect-error TS(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
          value={dateString}
          onChange={onInputChange}
        />
        <Calendar
          // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'Date | unde... Remove this comment to see the full error message
          activeStartDate={activeStartDate}
          onActiveStartDateChange={onActiveStartDateChange}
          formatShortWeekday={(locale, weekday) =>
            ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"][weekday.getDay()]
          }
          value={date ? date : null}
          onChange={onCalendarChange}
          prevLabel={<img src={arrowLeft} alt="image" />}
          nextLabel={<img src={arrowRight} alt="image" />}
        />
        <button
          className="table-button set-today"
          data-testid="date-cell-set-today"
          onClick={setToday}
        >
          Set Today
        </button>
      </div>
    </Popup>
  );
}

export default TaskDateSelect;
